import keys from '../../utilities/keys';
import { toCamelCaseKeysNested } from '../../utilities/mapKeysNested';
import { type ApplePayAvailabilityResponse } from './types';

export const APPLEPAY_SUPPORTED_VERSION = 4;

export const UnavailabilityReasons = {
  VERSION_NOT_SUPPORTED: 'VERSION_NOT_SUPPORTED',
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  NOT_CONFIGURED: 'NOT_CONFIGURED',
} as const;

export function getApplePayAvailability(): ApplePayAvailabilityResponse {
  let availability: ApplePayAvailabilityResponse;
  if ('ApplePaySession' in window) {
    const canMakePayments = ApplePaySession.canMakePayments();
    if (!ApplePaySession.supportsVersion(APPLEPAY_SUPPORTED_VERSION)) {
      availability = {
        available: false,
        reason: UnavailabilityReasons.VERSION_NOT_SUPPORTED,
      };
    } else if (!canMakePayments) {
      availability = { available: false, reason: UnavailabilityReasons.NOT_CONFIGURED };
    } else {
      availability = { available: true };
    }
  } else {
    availability = { available: false, reason: UnavailabilityReasons.NOT_SUPPORTED };
  }
  return availability;
}

/**
 * TODO: Remove this shim once the API types are aligned.
 */
export function convertApplePayPaymentInfo(
  info: io.flow.apple.pay.v0.models.ApplePayPaymentInfo,
): ApplePayJS.ApplePayPaymentRequest {
  // eslint-disable-next-line max-len
  const request: ApplePayJS.ApplePayPaymentRequest = toCamelCaseKeysNested<io.flow.apple.pay.v0.models.ApplePayPaymentInfo>(info);
  // apple pay does not like empty bad fields.
  keys(request).forEach((key) => {
    if (request[key] == null || request[key] === '') delete request[key];
  });
  return request;
}
